import type { Feed, FeedMetadata } from '@knocklabs/client'
import { requestInboxFeed } from '#src/hooks/inbox/inboxFeedRequest.ts'

// The badge counts, read as an absolute server snapshot rather than derived.
//
// A count computed locally cannot be right: it is blind to items outside the
// loaded page, blind to the row live removal deliberately withholds while its
// detail panel is open, and it has no causal ordering against the counts the
// socket pushes, so a push and a local decrement can double-count the same
// archive. Only the server knows the number, so only the server supplies it.

// One entry is requested because the response has no meta-only form.
export async function fetchInboxMetadata(
  feedClient: Feed
): Promise<FeedMetadata | undefined> {
  const response = await requestInboxFeed(feedClient, { page_size: 1 })
  return response?.meta
}

// Commits a snapshot over whatever the store holds, leaving items, pageInfo,
// loading and networkStatus untouched. Absolute by design: this never adds to
// or subtracts from the current counts.
export function applyInboxMetadata(
  feedClient: Feed,
  metadata: FeedMetadata
): void {
  feedClient.store.setState((state) => ({ ...state, metadata }))
}
